<template>
  <div :class="['dialog', wrapCls]" :style="wrapStyle" v-if="visible">
    <div class="mask"></div>
    <div class="dialog-container animated fadeIn">
      <div class="dialog-header">
        <div class="dialog-title" v-if="title">{{title}}</div>
        <div class="dialog-close">
          <button class="close-icon" @click="toggle(false)">
            <i class="iconfont">&#xe674;</i>
          </button>
        </div>
      </div>
      <div :class="['dialog-body', bodyCls]" :style="bodyStyle">
        <slot></slot>
      </div>
    </div>
  </div> 
</template>

<script>
export default {
  name: "Dialog",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    wrapCls: {
      type: String,
      default: ""
    },
    wrapStyle: {
      type: Object,
      default: () => {}
    },
    bodyCls: {
      type: String,
      default: ""
    },
    bodyStyle: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visible: this.show
    }
  },
  methods: {
    toggle(visible) {
      this.visible = visible || !this.visible;
      this.$emit(this.visible ? 'show' : 'hide', {});
    }
  },
  watch: {
    show() {
      this.visible = this.show;
    }
  }
}
</script>

<style lang="css" scoped>
  .dialog .mask { position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 10; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.3); }
  .dialog .dialog-container {
    box-sizing: border-box; position: fixed; top: 50%; left: 50%; z-index: 11; transform: translate(-50%, -50%); 
    background: #FFF; border-radius: 4px; min-width: 300px; min-height: 200px; box-shadow: 0 0 10px 0 #CCC;
  }
  .dialog .dialog-container .dialog-header { position: relative; text-align: left; }
  .dialog .dialog-container .dialog-header .dialog-title {
    font-size: 1rem; color: #000; font-weight: 400; border-bottom: 1px solid #b4b5b4;  width: calc(100% - 40px); box-sizing: border-box;
  }
  .dialog .dialog-container .dialog-header .dialog-close {
    width: 32px; height: 32px; position: absolute; top: 11px; right: 11px; z-index: 12; padding: 0; margin: 0;
    border: none; border-radius: 0; background-color: transparent; font-size: 0; cursor: pointer;
  }
  .dialog .dialog-container .dialog-header .dialog-close .close-icon {
    /* background: url(../assets/imgs/icons/close.svg) center center no-repeat; */
    height: 32px; width: 32px; margin: 0; padding: 0; display: block; overflow: hidden; cursor: pointer;
  }
  .dialog .dialog-container .dialog-header .dialog-close .close-icon .iconfont { font-size: 30px; color: #999999; }
  .dialog .dialog-container .dialog-body { display: flex; box-sizing: border-box; }
</style>